// extracted by mini-css-extract-plugin
module.exports = {"output":"todo_output__sl9s2"};